import {Injectable} from "@angular/core";
import {environment} from "../../config/environment";
import {MyHttp} from "../../core/http";

@Injectable()
export class UploadService {

  constructor(private http: MyHttp){}

  deleteFile(id: number){
    return this.http.delete(`${environment.API}/upload/file/${id}`)
      .map(res => res.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/components/uploader/upload.service.ts